import { MapPinIcon } from '@heroicons/react/24/outline';
import { HomeIcon, UserIcon } from '@heroicons/react/24/solid';
import { ChatBubbleBottomCenterIcon } from '@heroicons/react/24/outline';

export enum MapIconType {
  pin = 'pin',
  currentUserLocation = 'user',
  worker = 'worker',
  workerMatch = 'workerMatch',
  office = 'office',
  elecare = 'elecare',
  hbs = 'hbs',
}

type MapPinProps = {
  fillColor?: string;
  lineColor?: string;
  dotColor?: string;
  iconType?: MapIconType;
  workerId?: number;
  className?: string;
  hideNumber?: boolean;
  reserved?: boolean;
};

function MapPin({
  fillColor = 'text-white',
  lineColor = 'text-black',
  dotColor = 'bg-black',
  iconType = MapIconType.pin,
  workerId,
  className,
  hideNumber = false,
  reserved = false,
}: MapPinProps) {
  const size = 'size-8';
  return (
    <div className={'relative ' + className}>
      {iconType === MapIconType.office && (
        <HomeIcon className={`${size} fill-current text-yellow-600`} />
      )}
      {iconType === MapIconType.currentUserLocation && (
        <UserIcon className={`${size} fill-current text-blue-800`} />
      )}
      {iconType === MapIconType.hbs && (
        <>
          <MapPinIcon className={`${size} fill-current text-white`} />
          <MapPinIcon className={`absolute top-0 ${size} text-black`} />
          <div className="absolute left-3 top-2.5 z-10 size-2 rounded-full bg-white" />
        </>
      )}
      {iconType === MapIconType.worker && (
        <div className="relative flex size-full items-center justify-center">
          <UserIcon className={`z-0 ${size} fill-current text-red-600`} />
          {!hideNumber && (
            <div
              className="absolute bottom-0.5 left-1/2 -translate-x-1/2 text-xs font-bold text-white"
              style={{ zIndex: 9999 }}
            >
              {workerId}
            </div>
          )}
        </div>
      )}
      {iconType === MapIconType.workerMatch && (
        <div className="relative flex size-full items-center justify-center">
          <UserIcon className={`z-0 ${size} fill-current text-blue-800`} />
          {!hideNumber && (
            <div
              className="absolute bottom-0.5 left-1/2 -translate-x-1/2 text-xs font-bold text-white"
              style={{ zIndex: 9999 }}
            >
              {workerId}
            </div>
          )}
        </div>
      )}
      {iconType === MapIconType.elecare && (
        <>
          <ChatBubbleBottomCenterIcon className={`size-7 fill-current ${fillColor}`} />
          <ChatBubbleBottomCenterIcon className={`absolute top-0 size-7 ${lineColor}`} />
          {reserved ? (
            <div className="absolute left-2.5 top-2 z-10 size-2 rounded-full bg-black" />
          ) : (
            <div className="absolute left-2.5 top-2 z-10 size-2 rounded-full border border-black bg-white" />
          )}
        </>
      )}
      {iconType === MapIconType.pin && (
        <>
          <MapPinIcon className={`${size} fill-current ${fillColor}`} />
          <MapPinIcon className={`absolute top-0 ${size} ${lineColor}`} />
          <div className={`absolute left-3 top-2.5 z-10 size-2 rounded-full ${dotColor}`} />
        </>
      )}
    </div>
  );
}

export default MapPin;
